
import SquareEmpty from "../../../assets/outline/SquareEmpty.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function SquareEmptyIcon({ className, dataTestid = "SquareEmptyIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <SquareEmpty data-testid={dataTestid} className={classes} {...rest} />
  );
}
